import { FareBreakupProps } from '@/src/types/FareBreakup'
import { Box, Divider, Typography } from '@mui/material'
import { useTranslations } from 'next-intl'
import BreakupList from './BreakupList'
import { getPaymentMethodLabel } from '@/src/constants/payment'

function FareBreakup(props: FareBreakupProps) {
    const {
        perPaxPricing,
        travellerCallout,
        showHeader = true,
        priceSummary: { pricingElements = [], finalPricing = {}, featureFareBreakUpDetails = {} } = {},
        isBottomSheet = false,
        isAppPush = false,
        formatCurrency,
        paymentMethod
    } = props || {}
    const { pricingElements: appPushPricingElements = [], finalPricing: appPushFinalPricing = {} } =
        featureFareBreakUpDetails?.AppPush || {}
    const isDiscountArray = ['CB', 'DIS', 'SC']
    // let itineraryData = useAppSelector(getItineraryData)
    // const isCfwUser = itineraryData?.SEARCH_DETAILS?.itineraryTags?.includes('CFW')
    let showMediCancel = false
    // const { SEARCH_DETAILS = {} } = itineraryData || {}
    const totalPriceData = isAppPush ? appPushFinalPricing : finalPricing

    // if (!isEmpty(SEARCH_DETAILS)) {
    //   const { departDateTime = '' } = SEARCH_DETAILS
    //   let formattedDate = getFormattedDate(departDateTime, 'DD/MM/YYYY', 'YYYY-MM-DDTHH:mm:ssZ')
    //   showMediCancel = checkShowMediCancel(formattedDate)

    const t = useTranslations('itineraryPage.pricing')
    const tPayment = useTranslations('paymentMethods')
    return (
        <>
            <Box id="fare_breakup" data-testid="fare_breakup">
                {showHeader && !isAppPush && (
                    <>
                        <Typography variant="h6" fontWeight={700} sx={{ mb: 0.75, fontSize: '1.125rem' }}>
                            {t('fareSummary')}
                        </Typography>
                        {false && paymentMethod && (
                            <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ mb: 1.5 }}>
                                <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.825rem' }}>
                                    {t('paymentMethod')}
                                </Typography>
                                <Typography variant="body2" fontWeight={600} sx={{ fontSize: '0.825rem' }}>
                                    {tPayment(getPaymentMethodLabel(paymentMethod))}
                                </Typography>
                            </Box>
                        )}
                    </>
                )}
                <BreakupList
                    cfw={false}
                    perPaxPricing={perPaxPricing}
                    travellerCallout={travellerCallout}
                    pricingElements={pricingElements}
                    showHeader={showHeader}
                    formatCurrency={formatCurrency}
                />
                <Divider sx={{ my: 1.5 }} />
                <Box display="flex" alignItems="center" justifyContent="space-between">
                    <Typography variant="subtitle1" fontWeight={700} sx={{ fontSize: '1rem' }}>
                        {totalPriceData?.displayText || t('totalBookingAmount')}
                    </Typography>
                    <Typography variant="subtitle1" fontWeight={700} sx={{ fontSize: '1rem' }}>
                        {formatCurrency(totalPriceData?.amount)}
                    </Typography>
                </Box>
            </Box>
        </>
    )
}

export default FareBreakup
